import { useState } from "react";
import { toast } from "sonner";
import { Dices } from "lucide-react";
import { Card } from "@/components/ranger/PageHeader";
import { BetForm, GameTable, GameTabs, LABEL, ResultLine, TABLE_GAMES, outcome } from "@/components/portal/CasinoParts";
import { api, errMsg } from "@/lib/api";

const useCasino = (d, cid, reload) => {
  const cur = d.community.currency;
  const [live, setLive] = useState(() => Object.fromEntries(d.active_games.map((g) => [g.game, g])));
  const [last, setLast] = useState(null);
  const finish = (r) => { setLast(r); toast[r.won ? "success" : "message"](outcome(r, cur)); reload(); };
  const settle = (r) => {
    if (!r.state) { setLive((l) => ({ ...l, [r.game]: r })); return; }
    setLive((l) => ({ ...l, [r.game]: r.state }));
    finish(r);
  };
  const play = async (game, f) => {
    const { data } = await api.post(`/player/${cid}/casino/${game}`, { bet: Number(f.bet), choice: f.choice, mines: Number(f.mines) });
    setLast(null);
    if (TABLE_GAMES.includes(data.game)) settle(data); else finish(data);
  };
  const move = async (game, action, tile = 0) => settle((await api.post(`/player/${cid}/casino/game/${live[game].id}`, { action, tile })).data);
  return { cur, live, last, setLast, play, move };
};

export const CasinoCard = ({ d, cid, reload }) => {
  const games = d.casino.enabled ? d.casino.games.filter((x) => LABEL[x]) : [];
  const [game, setGame] = useState(games[0]);
  const [f, setF] = useState({ bet: d.casino.min_bet, choice: "", mines: 3 });
  const c = useCasino(d, cid, reload);
  if (!games.length) return null;
  const { min_bet: min, max_bet: max } = d.casino;
  const submit = async (e) => {
    e.preventDefault();
    if (Number(f.bet) < min || Number(f.bet) > max) { toast.error(`Bets must be between ${min} and ${max}`); return; }
    try { await c.play(game, f); } catch (err) { toast.error(errMsg(err)); }
  };
  const move = async (action, tile) => { try { await c.move(game, action, tile); } catch (err) { toast.error(errMsg(err)); } };
  const pick = (x) => { setGame(x); setF({ ...f, choice: "" }); c.setLast(null); };
  const g = c.live[game];
  const active = g && g.status === "active";
  return (
    <Card title="Casino" icon={Dices} testId="portal-casino">
      <GameTabs games={games} game={game} onPick={pick} />
      {active ? <GameTable game={game} g={g} move={move} /> : <BetForm game={game} cfg={d.casino} f={f} setF={setF} onSubmit={submit} />}
      {g && !active && <div className="mt-4"><GameTable game={game} g={g} move={move} /></div>}
      {c.last && <ResultLine last={c.last} cur={c.cur} />}
      <p className="mt-3 text-xs text-slate-500">Bets {min}–{max} {c.cur}, from your wallet only.</p>
    </Card>
  );
};
